import { UserStore } from '@/store/user';
import { raykouApi } from '@utils/axios';
import { Reservations } from '@/services/reservations/types';

const { user } = UserStore.getState();

export const getReservations = async ():Promise<Reservations[]> => {
  try {
    if (!user || !user.companySelected || !user.companySelected.id)
      throw new Error('company id is undefined');
    const res = await raykouApi.get('/reservations/company?status=ALL', {
      headers: {
        company: user.companySelected.id,
      },
    });

    return res.data;
  } catch (error) {
    console.log(error);

    return [];
  }
};

export const saveReservation = async (data: Reservations) => {
    if (!user || !user.companySelected || !user.companySelected.id)
      throw new Error('company id is undefined');

    const res = await raykouApi.post('/reservations', data, {
      headers: {
        company: user.companySelected.id,
        branch: data.branch,
      },
    });
    return res.data;
}
export const changeStatusReservation = (id: string) => async (data: {status: string}) => {

    const res = await raykouApi.patch(`/reservations/status/${id}`, {status: data.status.toUpperCase()}, {
    });
    return res.data;
}
